<app-auth-layout [isFullWidth]="currentView === 'check-email' || currentView === 'link-expired'">
  <!-- Login Form View -->
  <app-login-form *ngIf="currentView === 'login'" (forgotPasswordClick)="showForgotPassword()"
    (microsoftLoginClick)="handleMicrosoftLogin()">
  </app-login-form>

  <!-- Forgot Password Form View -->
  <app-forgot-password-form *ngIf="currentView === 'forgot-password'" (backClick)="backToLogin()"
    (submitSuccess)="showCheckEmail($event)">
  </app-forgot-password-form>

  <!-- Check Email View -->
  <app-check-email *ngIf="currentView === 'check-email'" [email]="submittedEmail" (backClick)="backToLogin()"
    (resendClick)="handleResendEmail()">
  </app-check-email>

  <!-- Set/Create Password View -->
  <app-set-password-form *ngIf="currentView === 'set-password'" [mode]="setPasswordMode" [token]="resetToken"
    [email]="submittedEmail" (backClick)="backToLogin()" (success)="handlePasswordSetSuccess()"
    (linkExpired)="handleLinkExpired()">
  </app-set-password-form>

  <!-- Link Expired View -->
  <app-link-expired *ngIf="currentView === 'link-expired'" (backClick)="backToLogin()">
  </app-link-expired>
</app-auth-layout>